import React, { useState } from 'react';
import './SuperAdmin.css';

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'YOUR_API_ENDPOINT_HERE';

function SuperAdmin({ idToken, onBack }) {
  const [form, setForm] = useState({ aircraftId: '', managerEmail: '', managerFirstName: '', managerLastName: '' });
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    try {
      const res = await fetch(`${API_ENDPOINT}/aircraft`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': idToken
        },
        body: JSON.stringify(form)
      });

      const result = await res.json();
      if (!res.ok) {
        throw new Error(result.message || 'Failed to add aircraft');
      }

      setMessage(result.message);
      setForm({ aircraftId: '', managerEmail: '', managerFirstName: '', managerLastName: '' });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="super-admin-container">
      <div className="super-admin-header">
        <h1>Super Admin - Add Aircraft</h1>
        <button onClick={onBack} className="back-btn">Back</button>
      </div>

      <div className="add-aircraft-form">
        <h2>Add New Aircraft</h2>
        {message && <div className="success-msg">{message}</div>}
        {error && <div className="error-msg">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label>Aircraft ID (e.g., G-GEEP) *</label>
            <input
              type="text"
              value={form.aircraftId}
              onChange={(e) => setForm({...form, aircraftId: e.target.value.toUpperCase()})}
              placeholder="G-XXXX"
              required
            />
          </div>

          <div className="form-field">
            <label>Manager Email *</label>
            <input
              type="email"
              value={form.managerEmail}
              onChange={(e) => setForm({...form, managerEmail: e.target.value})}
              required
            />
          </div>

          <div className="form-field">
            <label>Manager First Name</label>
            <input
              type="text"
              value={form.managerFirstName}
              onChange={(e) => setForm({...form, managerFirstName: e.target.value})}
            />
          </div>

          <div className="form-field">
            <label>Manager Last Name</label>
            <input
              type="text"
              value={form.managerLastName}
              onChange={(e) => setForm({...form, managerLastName: e.target.value})}
            />
          </div>

          <button type="submit" className="submit-btn">Add Aircraft</button>
        </form>

        <div className="info-box">
          <h3>What this does:</h3>
          <ul>
            <li>Creates aircraft group (e.g., G-GEEP)</li>
            <li>Creates manager group (e.g., G-GEEP-manager)</li>
            <li>Creates or invites manager user</li>
            <li>Assigns manager to both groups</li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SuperAdmin;
